import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { ReferentialCode } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import * as R from 'ramda';
import { MaintenanceProducer, TopProducer } from '../../../interfaces/Case';

interface ITopProducerComponentState {
  newTopProducer: TopProducer;
  topProducerList: TopProducer[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newTopProducerId: number | null;
  countryList: IReferential[];
}
type ITopProducerComponentProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class TopProducerComponent extends React.PureComponent<
  ITopProducerComponentProps,
  ITopProducerComponentState
> {
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appReferentialService!: IReferentialService;
  static contextType = ApplicationContext;
  private newTopProducer = {
    id: 0,
    countryId: 0,
    country: null,
    producer: ''
  } as TopProducer;

  state = {
    topProducerList: [],
    isLoading: false,
    selectedFilter: 0,
    isDialogOpen: false,
    newTopProducer: this.newTopProducer,
    newTopProducerId: null,
    countryList: [] as IReferential[]
  } as ITopProducerComponentState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadTopProducerList();
      }
    );
  }

  loadTopProducerList = async () => {
    const countryRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.Country
    );
    const [topProducerList, countryList] = await Promise.all([
      this.caseService.TopProducerList(),
      this.appReferentialService.Get(countryRef!.baseUrl)
    ]);

    topProducerList.forEach(item => {
      const country = countryList.find(countryItem => !R.isNil(item.countryId) && countryItem.id === item.countryId);
      item.country = R.isNil(country) ? null : country;
    });  

    this.setState({
      topProducerList: topProducerList,
      isLoading: false,
      newTopProducer: { ...this.newTopProducer },
      countryList: countryList
    });
  };

  private handleCountryChange = (newValue: IReferential | null) => {
    this.setState({
      newTopProducer: {
        ...this.state.newTopProducer,
        country: newValue,
        countryId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleProducerChange = (value: string) => {
    this.setState({
      newTopProducer: {
        ...this.state.newTopProducer,
        producer: value
      }
    });
  };
  
  public saveTopProducer = async () => {
    if (this.state.newTopProducerId === null) {
      try {
        await this.caseService.AddTopProducer(this.state.newTopProducer);
        await this.loadTopProducerList();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.caseService.UpdateTopProducer(this.state.newTopProducer);
        await this.loadTopProducerList();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveTopProducer} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="country"
            fullWidth
            options={this.state.countryList}
            value={this.state.newTopProducer.country}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleCountryChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="country"
                value={this.state.newTopProducer.country || ''}
                label={this.translatorService.Tranlate(
                  'EDIT_ORGANIZATION_COUNTRY_LABEL',
                  'Tara'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="producer"
            id="producer"
            value={this.state.newTopProducer.producer || ''}
            onChange={(e: any) => this.handleProducerChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'CALCULATION_DETAILS_PRODUCER_HEADER',
              'Producator'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>

        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }
  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'country',
        label: this.translatorService.Tranlate('ORGANIZATIONS_COUNTRY_HEADER', 'Tara'),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            debugger;
            return a.name!.localeCompare(b.name!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'producer',
        label: this.translatorService.Tranlate(
          'CALCULATION_DETAILS_PRODUCER_HEADER',
          'Producator'
        ) 
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newTopProducerPopup(tableMeta.rowData[0])}
                >
                    <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteTopProducer(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];
    return columns;
  };

  deleteTopProducer = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.caseService.RemoveTopProducer(id);
      await this.loadTopProducerList();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newTopProducerPopup = async (topProducerId: number | null) => {
    let newTopProducer: TopProducer;
    if (topProducerId == null) {
      newTopProducer = { ...this.state.newTopProducer } as TopProducer;
    } else {
      newTopProducer = this.state.topProducerList.find((item) => item.id === topProducerId)!;
    }
    this.setState({
      isDialogOpen: true,
      newTopProducer: newTopProducer,
      newTopProducerId: topProducerId
    });
  };

  closeDialog = async () => {
    this.setState(
        { 
          isDialogOpen: false, 
          newTopProducer: this.newTopProducer 
        }
      );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newTopProducerPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };
    return (
      <Fragment>
    
       <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.topProducerList}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                  {!this.state.newTopProducerId ? 
                    this.translatorService.Tranlate(
                      'TOP_PRODUCER_ADD_MODAL_TITLE',
                      'Adauga Producator top'
                    ) : this.translatorService.Tranlate(
                      'TOP_PRODUCER_UPDATE_MODAL_TITLE',
                      'Actualizeaza Producator top'
                    )}               
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>) : null}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(TopProducerComponent as any));